/* global acalltracker */
import { getPageDataKeyValue } from 'js/tools';
import registerEvent from 'js/web-event-api-wrapper';

export default context => {
    const vehicleId = context.getAttribute('data-track-label');
    const pageType = getPageDataKeyValue('pageType');

    context.addEventListener('click', e => {
        const clickedAttr = context.getAttribute('data-clicked');
        const eventName = clickedAttr ? `${pageType}-phone-dialer-displayed` : `${pageType}-phone-number-displayed`;

        registerEvent({
            eventName,
            payload: {
                vehicleId
            }
        });

        if (!clickedAttr) {
            e.preventDefault();
            context.setAttribute('data-clicked', true);
            context.classList.add('clicked');

            if (context.getAttribute('data-aen')) {
                context.classList.add('calltracker-fixed');
                context.querySelector('[data-aen]').classList.add('calltracker');

                if (typeof acalltracker !== 'undefined') {
                    acalltracker.dynamicContentload();
                }
            }
        }
    });
};
